import { SettingsIcon } from '@mm/icons';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Popover from 'react-tiny-popover';
import useRouter from 'use-react-router';
import { OnClickElsewhere } from '../../../../../common/components/OnClickElsewhere/OnClickElsewhere';
import { UserRoleContainer } from '../../../../../common/hooks/use-route-guard';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { SettingsRoutes } from '../../../../../routes/settings-routes';
import './LiveChatMenu.pcss';

export const LiveChatMenu = () => {
  const { history } = useRouter();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const [showMenu, setShowMenu] = useState(false);
  const {
    roleFlags: { isLiveChatAgent },
  } = UserRoleContainer.useContainer();

  if (!chatbotId) {
    return null;
  }

  const menuItems = [
    {
      name: 'Notification Settings',
      path: SettingsRoutes.myAccount.getLink(),
    },
    {
      name: 'Agent Persona',
      path: SettingsRoutes.myAccount.getLink(),
    },
    ...(!isLiveChatAgent
      ? [
          {
            name: 'Business Hours',
            path: BotBuilderRoutes.automationRules.getLink({
              chatbotId,
              kind: 'business_hours',
            }),
          },
        ]
      : []),
  ];

  return (
    <OnClickElsewhere
      className="live-chat-menu"
      handleClick={() => setShowMenu(false)}
    >
      <Popover
        position="bottom"
        align="start"
        isOpen={showMenu}
        content={
          <div className="live-chat-menu__content">
            {menuItems.map(i => (
              <div
                className="live-chat-menu__item"
                onClick={() => history.push(i.path)}
                key={i.name}
              >
                {i.name}
              </div>
            ))}
          </div>
        }
      >
        <div
          className={classnames('live-chat-menu__settings-button', {
            'live-chat-menu__settings-button--active': showMenu,
          })}
          onClick={() => setShowMenu(c => !c)}
        >
          <SettingsIcon className="live-chat-menu__settings-icon" />
        </div>
      </Popover>
    </OnClickElsewhere>
  );
};
